import {Component} from '@angular/core';

@Component({
  selector: 'app-match-testimony',
  imports: [],
  templateUrl: './match-testimony.component.html'
})
export class MatchTestimonyComponent {

}
